<template>
  <el-table :data="records">
    <el-table-column label="登录方式" prop="content" align="left">
    </el-table-column>
    <el-table-column label="员工姓名" prop="user_name" align="left">
    </el-table-column>
    <el-table-column label="登录IP" prop="ip" align="left"> </el-table-column>
    <el-table-column label="登录类型" prop="category_name" align="left">
    </el-table-column>
    <el-table-column label="操作时间" align="left">
      <template slot-scope="scope">
        {{ $time(scope.row.created_at).format('YYYY-MM-DD HH:mm') }}
      </template>
    </el-table-column>
    <el-table-column label="登录结果" align="left" prop="result">
      <template slot-scope="scope">
        <status-tag
          v-if="scope.row.result == 1"
          class="font-12"
          type="success"
          name="成功"
        ></status-tag>
        <status-tag
          v-else
          class="font-12"
          type="danger"
          name="失败"
        ></status-tag>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  props: {
    records: {
      type: Array,
      default: () => [],
    },
  },
}
</script>